import {DojoDeshi} from './DojoDeshi.js';
import {DojoTemplates} from './DojoTemplates.js';
import {Eventify} from './Eventify.js';
import signals from './lib/signals.js';

import {StudentAttendanceByDateBadges} from './StudentAttendanceByDateBadges.js';

export class StudentListTableRow {
	constructor(parent, student, studentListModel, studentSelectModel,
		studentInfoForm) {
		this.selectModel = studentSelectModel;
		this.infoForm = studentInfoForm;
		[this.el, this.$] = DojoTemplates('StudentListTableRow2');
		Eventify(this.el,
		{
			"editClick":evt=>{
				if (null==this.student) return;
				evt.preventDefault();
				evt.stopPropagation();
				document.location = `/students/edit/${this.student.Id}`;
			},
			"selectClick":evt=>{
				this.selectModel.toggle(this.student, this);
			},
			"stateClick":evt=>{
				if (null==this.student) return;
				evt.preventDefault();
				evt.stopPropagation();
				let thisStateId = this.student.State.Id;
				this.selectModel.selectFor(function(s) {
					return (s.State.Id==thisStateId);
				});
			},
			"infoClick":evt=>{
				if (null==this.student) return;
				evt.preventDefault();
				evt.stopPropagation();
				this.infoForm.open(this.student);
			},
			"vcardClick":evt=>{
				if (null==this.student) return;
				evt.preventDefault();
				evt.stopPropagation();
				document.location=`/students/vcard/${this.student.Id}.vcard`;
			}
		}, this);
		parent.appendChild(this.el);
		this.studentListModel = studentListModel;
		studentListModel.removed.add(this.studentRemoved, this);
		this.selectModel.selected.add(this.studentSelected, this);
		this.setStudent(student);
	}
	setStudent(student=null) {
		this.student = student;
		this.$.Surname.textContent = student.Surname;
		this.$.Firstname.textContent = student.Firstname;
		this.$.Email.href = `mailto:${student.Email}`
		this.$.Email.textContent = student.Email;
		this.$.Mobile.href = `tel:${student.Mobile}`
		this.$.Mobile.textContent = student.Mobile;
		this.$.State.textContent = student.State.Name;

		this.$.Attendance.textContent = '...';
		new StudentAttendanceByDateBadges(this.$.Attendance, student.Id);
	}
	studentRemoved(student, src) {
		if (this.student.Id == student.Id) {
			this.studentListModel.removed.remove(this.studentRemoved, this);
			this.selectModel.selected.remove(this.studentSelected, this);
			this.el.parentNode.removeChild(this.el);
		}
	}
	studentSelected(student, selected, src) {
		if ((null==this.student) || (student.Id != this.student.Id)) {
			return;
		}
		this.$.selectCheckbox.checked = selected;
	}
}